module.exports = __webpack_public_path__ + "static/media/DSC_0282.ee8ffbee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0282.jpg
// module id = 660
// module chunks = 0